import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetDiagnosisDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Diagnosis/GetDetail?` + params, null);

export const GetDiagnosisList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Diagnosis/GetList?` + params, null);

export const CreateDiagnosis = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Diagnosis/Create`, data);

export const UpdateDiagnosis = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Diagnosis/Update`, data);

export const DeleteDiagnosis = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Diagnosis/Delete`, data);
